var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"main-card pa-3"},[_c('VehicleListFilterBar'),_c('VehicleListTable'),_c('VehicleListPagination'),_c('VehicleDetailModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }